import { Select } from "@totalenergiescode/mobility-business-rev-design-system";
import { Controller, FieldValues } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { ControlledSelectProps } from "@/components/shared/ControlledSelect/types";

export const ControlledSelect = <T extends FieldValues>({
  name,
  control,
  namespace,
  selectProps,
}: ControlledSelectProps<T>) => {
  const { t } = useTranslation(namespace);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => {
        const isError =
          typeof selectProps.error !== "undefined"
            ? selectProps.error
            : !!fieldState.error;
        const errorMessage = selectProps.errorMessage
          ? selectProps.errorMessage
          : fieldState.error?.message && namespace
            ? t(fieldState.error.message, { ns: namespace })
            : undefined;

        return (
          <Select
            {...selectProps}
            value={field.value}
            onChange={(event, child) => {
              field.onChange(event);
              selectProps.onChange?.(event, child);
            }}
            error={isError}
            errorMessage={errorMessage}
          />
        );
      }}
    />
  );
};
